export const MAX_LIST_ROWS = 250
export const MAX_WORKUNITGROUP_ROWS = 50000
